module.exports = __webpack_public_path__ + "static/media/home-inking-dancers.bd9e5950.jpg";